<div class="container-headline pt-3">
  <app-teitl-tudalen [eicon]="'question-circle'" [teitl]="'ui.cymorth' | translate"></app-teitl-tudalen>
</div>

<div class="mat-font-headline-xs pt-3">
  {{ "ui.amgymorth" | translate }} <a [href]="nolHrefCymorth()">DesgGymorth&#64;gwynedd.llyw.cymru</a>
</div>

<div class="pt-3">
  <img [src]="nolLogoSystem()" alt="Asedau Fflyd" class="maint-logo-system" />
</div>

<div class="pt-1">{{ "ui.fersiwn" | translate }} - {{ fersiwnAp }}</div>

<div class="container-logo mt-5">
  <div><fa-icon class="eicon-hawlfraint pr-2" icon="copyright"></fa-icon> {{ "ui.hawlfraint" | translate }}</div>
  <div class="container-logo-lluniau">
    <img [src]="nolLogo()" alt="Logo Cyngor Gwynedd" class="maint-logo-cyngor" />

    <img [src]="nolLogoDatblygu()" alt="Logo Cyngor Gwynedd" class="maint-logo-datblygu" />
  </div>
</div>
